module.exports = __webpack_public_path__ + "static/autumn_eladrin-015ecffc56c27640c1eabdc2db07ef98.png";